import { useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

import { useCurrentAccount } from '@/shared/hooks/useCurrentAccount'

/**
 * Hook to guard the subscription flow.
 * If the current account already has an active (paid) subscription,
 * redirects the user to the home page.
 *
 * Suspended accounts are intentionally excluded from this redirect:
 * the 402 interceptor already sends blocked users to /subscribe, and
 * redirecting them away again would create a redirect loop.
 */
export const useSubscribeGuard = () => {
	const navigate = useNavigate()
	const account = useCurrentAccount()

	useEffect(() => {
		if (!account) return

		// Suspended accounts must stay on /subscribe so the blocked-account
		// modal is reachable; kicking them away causes a /subscribe <-> /zones loop.
		if (account.suspended) return

		// Check for active subscriptions that are not trials
		const activeSubscriptions = account.getActiveSubscriptions()
		const hasActivePaidSubscription = activeSubscriptions.some(
			(sub) => sub.status !== 'in_trial'
		)

		if (hasActivePaidSubscription) {
			navigate('/', { replace: true })
		}
	}, [account, navigate])
}
